export { default as deliveryRoutes } from "./delivery-routes";
